import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

import Carousel from 'react-bootstrap/Carousel';

import './styles.css';
import EditCarousel from '../EditCarousel';
import Spinner from 'react-bootstrap/Spinner';
import RestServices from '../services/RestServices.js';

class HomePage extends React.Component {
    state = {
        showLoading: false,
        alert: 0,
        alertMessage: '',
        flag1: false,
        rows: []
    };

    // rows1=[]
    async componentDidMount() {
        
        this.setState({ showLoading: true });

        await RestServices.getSliderImages(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    this.setState({
                        showLoading: false,
                        flag: 0,
                        alert: 1,
                        alertMessage: responseData.error
                    });
                } else {
                    this.setState({
                        showLoading: false,
                        flag1: true,
                        rows: responseData
                    });
                }
            })
            .catch((err) => {
                this.setState({
                    showLoading: false,
                    flag: 0,
                    alert: 1,
                    alertMessage: err.message
                });
            });
    }

    render() {
        return (
            <Container>
                {this.state.showLoading && <Spinner animation="border" />}
                <Row>
                    <Col>
                        <h4>Advertisements</h4>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {this.state.flag1 && (
                            <Tabs
                                defaultActiveKey="carousel"
                                id="uncontrolled-tab-example"
                            >
                                <Tab
                                    eventKey="carousel"
                                    title="Posts"
                                    style={{ height: '700px' }}
                                >
                                    <Carousel>
                                        {this.state.rows.map((row, index) => {
                                            return (
                                                <Carousel.Item key={row.name}>
                                                    <img
                                                        className="d-block w-100"
                                                        src={row.url}
                                                        alt={
                                                            row.name +
                                                            ' indiabuys-post'
                                                        }
                                                        height="400rem"
                                                    />
                                                </Carousel.Item>
                                            );
                                        })}
                                    </Carousel>
                                </Tab>
                                {this.props.role === 'Admin' && (
                                    <Tab eventKey="edit" title="Edit">
                                        <EditCarousel
                                            handleFlag={() =>
                                                this.setState(
                                                    !!this.state.flag1
                                                )
                                            }
                                        />
                                    </Tab>
                                )}
                            </Tabs>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(HomePage);
